import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f07d7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { videoStore } from '@/store/modules/Video';
import { resolvePath } from "@/utils/Path";
import AppTransition from "@/transition/AppTransition";


export default /*#__PURE__*/_defineComponent({
  __name: 'TransitionVideo',
  setup(__props) {

const root = ref(null);
const video = ref(null);
const rafID = ref(null);
const GLAppTransition = ref(null);
const canvasTransition = ref(null);
const isPlaying = computed(() => videoStore.play);

onMounted(async() => {
  video.value.addEventListener('ended', () => {
    videoStore.play = false;
  });
});

onBeforeUnmount(() => {
  cancelAnimationFrame(rafID.value);
});

watch(() => videoStore.play, (value) => {
  if(value) {
    video.value.currentTime = 0;

    GLAppTransition.value = new AppTransition({ 
      canvas: canvasTransition.value,
      video: video.value
    });
  } else {
    if(GLAppTransition.value) {
      GLAppTransition.value.destroy();
      GLAppTransition.value = null;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["transition-video", { 'hidden': !isPlaying.value }]),
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("canvas", {
      ref_key: "canvasTransition",
      ref: canvasTransition
    }, null, 512),
    _createElementVNode("video", {
      ref_key: "video",
      ref: video,
      muted: "",
      crossorigin: "anonymous",
      src: _unref(resolvePath)(require('@/assets/videos/ink.mp4'))
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})